


















































































































import { Component } from "vue-property-decorator";
import { NotificationHelper as _notification } from "@/helper/notifications.helper";
import { Utils } from "@/helper/utils";
import { VHeaders, PaginationModel } from "@/models/pagedlistmodel";
import {
  PaymentReportViewModel,
  VantivRefundViewModel,
} from "@/models/payment/paymentreport";
import {
  PaymentDetailViewModel,
  PaymentDetailResponseViewModel,
  PaymentCsvFileReport,
  PaymentCsvFileResponse,
} from "@/models/fixedops/repairorder";
import { Route } from "vue-router/types/router";
import { Base } from "@/components/common/base";
import { IDialogOption } from "@/models/dialog";
import { DateTimeHelper as _dateTime } from "@/helper/date-time.helper";
import { mask } from "vue-the-mask";
import downloadCsv from "download-csv";
import {
  userService,
  paymentReportService,
  repairOrderService,
  storeService,
  paymentService,
} from "@/shared";
import { RoleType } from "@/helper/enum";
import { mapGetters } from "vuex";
import { NotificationType } from '@/helper/enum';
@Component({
  props: ["methodName", "progress"],
  components: {
    AppGrid: () => import("@/components/common/app.grid.vue"),
    AppDialog: () => import("@/components/common/app.dialog.vue"),
    Calendar: () => import("@/components/common/app.calendar.vue"),
    SnackBarLoader: () => import('@/components/common/loader.vue'),
  },
  directives: {
    mask,
  },

  computed: {
    methodtoCall: {
      get() {
        return this.$props.methodName;
      },
    },
    ...mapGetters({ currentRoles: "getRoles" }),
  },
})
class PaymentReportPage extends Base {
  public isReceiptDownloading: boolean = false;
  public refundPreset: any[] = [];
  public identifier: string = "RO";
  public accountNumber: any = "";
  public hideAccountNumber: boolean = false;
  public loading: boolean = false;

  public retryDmsTxId: string = "";
  public retryDmsPaymentDetailId: string = "";
  public retryDmsPostStoreId: number = 0;
  public retryDmsRoNumber: string = "";
  public retryDmsIsDeductibleRO: boolean = false;
  public calendarKey = 0;
  public headers: VHeaders[] = [
    {
      align: "left",
      isNotDataProp: true,
      text: "",
      value: "",
      sortable: false,
    },
    {
      align: "left",
      sortable: true,
      text: this.$parent.$t(
        "repairOrderPaymentReport.roPaymentReportGrid.status"
      ) as string,
      value: "roStatus",
      filters: [
        (val, item) => {
          if (val === "CL") {
            return this.$parent.$t(
              "repairOrderPaymentReport.roPaymentReportGrid.closed"
            ) as string;
          } else {
            return this.$parent.$t(
              "repairOrderPaymentReport.roPaymentReportGrid.open"
            ) as string;
          }
        },
      ],
    },
    {
      align: "left",
      sortable: false,
      text: this.$parent.$t(
        "repairOrderPaymentReport.roPaymentReportGrid.lastModified"
      ) as string,
      value: "lastModified",
      filters: [
        (v) => {
          if (v && v !== "0001-01-01T00:00:00.0000000") {
            return this.$moment(v).format("lll");
          } else {
            return "N/A";
          }
        },
      ],
    },
    {
      align: "left",
      sortable: true,
      text: this.$parent.$t(
        "repairOrderPaymentReport.roPaymentReportGrid.ro"
      ) as string,
      value: "repairOrderNumber",
    },
    {
      align: "left",
      sortable: true,
      text: this.$parent.$t(
        "repairOrderPaymentReport.roPaymentReportGrid.customerName"
      ) as string,
      value: "customerName",
    },
    {
      align: "left",
      sortable: true,
      text: this.$parent.$t(
        "repairOrderPaymentReport.roPaymentReportGrid.advisor"
      ) as string,
      value: "advisorName",
    },
    {
      align: "left",
      sortable: true,
      text: this.$parent.$t(
        "repairOrderPaymentReport.roPaymentReportGrid.date"
      ) as string,
      value: "date",
      fieldType: "date",
    },
    {
      align: "center",
      text: this.$parent.$t(
        "repairOrderPaymentReport.roPaymentReportGrid.status2"
      ) as string,
      value: "status",
      fieldType: "template",
      template: (item) => {
        // tslint:disable-next-line:max-line-length
        return `<v-chip small text-color="white" :color="'${item.status === "Approved" ? "success" : "error"
          }'">${item.status}</v-chip>`;
      },
    },
    {
      align: "left",
      sortable: true,
      text: this.$parent.$t(
        "repairOrderPaymentReport.roPaymentReportGrid.totalAmount"
      ) as string,
      fieldType: "html",
      filters: [
        (val, item) => {
          if (val) {
            return item.amount.toFixed(2);
          } else {
            return "0.0";
          }
        },
      ],
      value: `amount`,
    },
  ];
  public paymentReport: PaymentReportViewModel = {
    totalAmountCollected: 0,
    totalAmountDue: 0,
  };
  public pagedPayment: PaymentDetailViewModel[] = [];
  public filterPagedPayment: PaymentDetailViewModel[] = [];
  public paymentCsvFileReport: PaymentCsvFileReport[] = [];
  public pagedPaymentResponse: PaymentDetailResponseViewModel[] = [];
  public PaymentResponse: PaymentDetailResponseViewModel;

  public userList: any[] = [];
  public statusList: any[] = [];
  public isSearchLoading: boolean = true;
  public maxToDate: any = _dateTime.currentDate(
    _dateTime.addDays(new Date(), 45)
  );
  public todayDate: any = _dateTime.currentDate(new Date());
  public isRefundAllowed: boolean = false;

  public params: any = {
    selecteduser: "",
    paymentstatus: "",
    startDate: "",
    endDate: "",
    isLiveStatus: true,
    selectedAccountNumber: "",
  };
  public flags: any = {
    invalidUrl: false,
    showStartDatePicker: false,
    showEndDatePicker: false,
    loading: false,
    showForm: false,
    showAttachmentDetails: false,
    showEmailPopup: false,
  };
  public showRefundPopup: IDialogOption = {
    width: 600,
    title: this.$parent.$t(
      "repairOrderPaymentReport.refundDialog.title"
    ) as string,
    model: false,
    action: {
      color: "success",
      icon: "fas fa-check",
      text: this.$parent.$t(
        "repairOrderPaymentReport.refundDialog.btnSubmit"
      ) as string,
      disable: false,
    },
    onAction: (): void => {
      this.confirmRefund();
    },
    onClose: (): void => {
      this.clear();
    },
  };

  public glRetryDialogPopup: IDialogOption = {
    width: 400,
    title: this.$parent.$t("dialogSettings.title") as string,
    model: false,
    loading: false,
    action: {
      color: "success",
      icon: "fas fa-check",
      text: this.$parent.$t("dialogSettings.btntxtAgree") as string,
    },
    onAction: (): void => {
      this.retryGlPost();
    },
  };

  public clear() {
    this.refundPreset = [];
    this.accountNumber = "";
    this.params.selectedAccountNumber = "";
    this.getRefundPreset();
    this.getAccountNumber();
  }
  public pagination = new PaginationModel("date", true);
  public search: string = "";

  public childPagination = new PaginationModel("date", true, -1);

  public actions: any[] = [];
  public constants: any = {
    minDate: "",
  };
  public userLoading: boolean = false;
  public statusLoading: boolean = false;
  public paymentProvider: string = "";
  public currentRoles: string[];
  public refund: VantivRefundViewModel = {};
  public paymentToRefund: PaymentDetailViewModel = null;
  public fileRef: any;
  public filters: string = "";
  public fromLocal: string = "true";
  public selectedFilter = [];
  public csvFileList: PaymentCsvFileResponse[] = [];
  public csvFileModel: PaymentCsvFileResponse = {};
  public paymentResponseHeaders: VHeaders[] = [
    {
      align: "left",
      text: this.$parent.$t(
        "repairOrderPaymentReport.roPaymentReportNestedGrid.approvalNumber"
      ) as string,
      value: "approvalNumber",
    },
    {
      align: "center",
      text: "User",
      fieldType: "template",
      sortable: false,
      template: (item) => {
        if (item) {
          if (
            item.updatedByEmail != undefined &&
            item.updatedByEmail != "" &&
            item.updatedByEmail != "system"
          ) {
            return `<span>${item.updatedByEmail}</span>`;
          } else {
            return `<span>${item.createdByEmail != undefined ? item.createdByEmail : ""
              }</span>`;
          }
        } else {
          return " ";
        }
      },
    },
    {
      align: "left",
      text: this.$parent.$t(
        "repairOrderPaymentReport.roPaymentReportNestedGrid.cardType"
      ) as string,
      value: "cardLogo",
    },
    {
      align: "left",
      text: this.$parent.$t(
        "repairOrderPaymentReport.roPaymentReportNestedGrid.lastFour"
      ) as string,
      value: "cardLastFour",
    },
    {
      align: "left",
      text: this.$parent.$t(
        "repairOrderPaymentReport.roPaymentReportNestedGrid.merchantId"
      ) as string,
      value: "acceptorIdLastFour",
    },
    {
      align: "left",
      text: this.$parent.$t(
        "repairOrderPaymentReport.roPaymentReportNestedGrid.date"
      ) as string,
      value: "date",
      fieldType: "date",
      format: "MMM Do YYYY h:mm:ss A",
    },
    {
      align: "center",
      text: this.$parent.$t(
        "repairOrderPaymentReport.roPaymentReportNestedGrid.method"
      ) as string,
      value: "paymentMethod",
      fieldType: "template",
      sortable: false,
      template: (item) => {
        if (item) {
          if (item.paymentMethod == "TriPOS")
            return `<v-chip small text-color="white" :color="'info'"> Terminal </v-chip>`;
          else
            return `<v-chip small text-color="white" :color="'info'">${item.paymentMethod}</v-chip>`;
        } else {
          return " ";
        }
      },
    },
    {
      align: "center",
      text: this.$parent.$t(
        "repairOrderPaymentReport.roPaymentReportNestedGrid.type"
      ) as string,
      value: "paymentType",
      fieldType: "template",
      sortable: false,
      template: (item) => {
        if (item) {
          return `<v-chip small text-color="white" :color="'warning'">${item.paymentType}</v-chip>`;
        } else {
          return " ";
        }
      },
    },
    {
      align: "center",
      text: this.$parent.$t(
        "repairOrderPaymentReport.roPaymentReportNestedGrid.status"
      ) as string,
      value: "status",
      fieldType: "template",
      sortable: false,
      template: (item) => {
        // tslint:disable-next-line:max-line-length
        return `<v-chip small text-color="white" :color="'${item.status === "Approved" ? "success" : "error"
          }'">${item.status}</v-chip>`;
      },
    },
    {
      align: "left",
      text: this.$parent.$t(
        "repairOrderPaymentReport.roPaymentReportNestedGrid.paidAmount"
      ) as string,
      sortable: false,
      value: "approvedAmount",
      // fieldType: 'template',
      // template: (item) => {
      //   if (item) {
      //     if (item.amountWithServiceCharges != undefined && item.amountWithServiceCharges != '' && item.status == 'Approved') {
      //       return `<span>${item.amountWithServiceCharges}</span>`;
      //     } else {
      //       return `<span>${item.approvedAmount}</span>`;
      //     }
      //   } else {
      //     return ' ';
      //   }
      // },
    },
    {
      align: "left",
      text: "Service Charges",
      // value: 'approvedAmount',
      fieldType: "template",
      sortable: false,
      template: (val) => {
        if (
          val.paymentType != "Return" &&
          val.amountWithServiceCharges != undefined &&
          val.amountWithServiceCharges != null &&
          val.amountWithServiceCharges != "" &&
          val.status == "Approved"
        ) {
          var ServiceCharges =
            val.amountWithServiceCharges - val.approvedAmount;
          return `<span>${ServiceCharges.toFixed(2)}</span>`;
        } else if (
          val.paymentType == "Return" &&
          val.amountWithServiceCharges != undefined &&
          val.amountWithServiceCharges != null &&
          val.amountWithServiceCharges != "" &&
          val.status == "Approved"
        ) {
          var ServiceCharges =
            val.amountWithServiceCharges * -1 - val.approvedAmount;
          return `<span>${ServiceCharges.toFixed(2)}</span>`;
        } else return `<span>0</span>`;
      },
    },
    {
      align: "left",
      text: "Bypass Reason",
      value: "byPassReason",
      sortable: false,
      fieldType: "template",
      template: (val) => {
        if (val.byPassReason) {
          return `<span>${val.byPassReason}</span>`;
        } else return `<span>N/A</span>`;
      },
    },
    {
      align: "left",
      text: this.$parent.$t(
        "repairOrderPaymentReport.roPaymentReportGrid.action"
      ) as string,
      isNotDataProp: true,
      sortable: false,
    },
  ];
  public columns1: any = {
    repairOrderNumber: this.$parent.$t(
      "repairOrderPaymentReport.CSV.repairOrderNumber"
    ) as string,
    customerName: this.$parent.$t(
      "repairOrderPaymentReport.CSV.customerName"
    ) as string,
    advisorName: this.$parent.$t(
      "repairOrderPaymentReport.CSV.advisorName"
    ) as string,
    date: this.$parent.$t("repairOrderPaymentReport.CSV.date") as string,
    status: this.$parent.$t("repairOrderPaymentReport.CSV.status") as string,
    paymentMethod: this.$parent.$t(
      "repairOrderPaymentReport.CSV.paymentMethod"
    ) as string,
    roStaus: this.$parent.$t("repairOrderPaymentReport.CSV.roStatus") as string,
    acceptorIdLastFour: this.$parent.$t(
      "repairOrderPaymentReport.CSV.acceptorIdLastFour"
    ) as string,
    cardLogo: this.$parent.$t(
      "repairOrderPaymentReport.CSV.cardLogo"
    ) as string,
    cardLastFour: this.$parent.$t(
      "repairOrderPaymentReport.CSV.cardLastFour"
    ) as string,
    approvalNumber: this.$parent.$t(
      "repairOrderPaymentReport.CSV.approvalNumber"
    ) as string,
    paymentType: this.$parent.$t(
      "repairOrderPaymentReport.CSV.paymentType"
    ) as string,
    amount: this.$parent.$t("repairOrderPaymentReport.CSV.amount") as string,
  };

  public confirmRefundDialog: IDialogOption = {
    width: 400,
    title: this.$parent.$t("dialogSettings.title") as string,
    model: false,
    loading: false,
    action: {
      color: "success",
      icon: "fas fa-check",
      text: this.$parent.$t("dialogSettings.btntxtAgree") as string,
      disable: false,
    },
    onAction: (): void => {
      this.processRefund();
    },
  };

  public setActions() {
    this.actions = [
      {
        type: "button",
        icon: "fas fa-retweet",
        title: "Retry Dms Post",
        visible: (model: any) => {
          if (model.isDeductiblePayment && model.status === "Approved") {
            if (model.approvedAmount > 0 && model.glStatus == false)
              return true;
            else return false;
          } else {
            return false;
          }
        },
        action: (model: PaymentDetailResponseViewModel) => {
          this.showRetryDmsPost(model);
          return ``;
        },
      },
      {
        type: "button",
        icon: "fas fa-undo-alt",
        title: this.$parent.$t(
          "repairOrderPaymentReport.roPaymentReportGrid.actionGrid.refund"
        ) as string,
        disable: (model: PaymentDetailResponseViewModel) => {
          if (
            (model.status !== "Approved" &&
              model.status !== "PartialApproved") ||
            model.approvedAmount < 0
          ) {
            return true;
          }
          return false;
        },
        action: (model: PaymentDetailResponseViewModel) => {
          this.showRefund(model);
          return ``;
        },
      },
      {
        type: "button",
        icon: "fas fa-eye",
        title: "View Receipt",
        color: "primary",
        visible: (model: any) => {
          if (model.status === "Approved") {
            return true;
          } else {
            return false;
          }
        },
        action: (model: any) => {
          this.downloadReceipt(model);
        },
      },
    ];
  }
  public formatDate(date) {
    if (!date) {
      return null;
    }
    const [year, month, day] = date.split("-");
    return `${month}/${day}/${year}`;
  }
  public created(): void {
    if (this.$route.query.startDate && this.$route.query.endDate) {
      this.params.startDate = this.$route.query.startDate.toString();
      this.params.endDate = this.$route.query.endDate.toString();
    } else {
      this.params.startDate = this.presentDate();
      this.params.endDate = this.presentDate();
    }
  }

  public beforeDestroy() {
    const buttons = [];
    this.$emit("updateToolBar", buttons);
  }
  public callMethod(methodName): void {
    if (methodName === "searchPayments") {
      this.searchPayments();
    }
    if (methodName === "downloadCSVFile") {
      if (this.paymentCsvFileReport.length > 0) {
        this.downloadCSVFile();
      } else {
        this.showAlert(
          false,
          this.$t("repairOrderPaymentReport.alertNoRecordFound")
        );
        this.$emit("resetMethodName", methodName);
        return;
      }
    }
    if (methodName !== "") {
      this.$emit("resetMethodName", methodName);
    }
  }

  public updateToolBar(): void {
    const buttons: any = [];
    buttons.push({
      id: "1",
      type: "button",
      title: this.$t("repairOrderPaymentReport.downloadCSVFile"),
      disabled: false,
      visible: true,
      class: "btn",
      label: this.$t("repairOrderPaymentReport.downloadCSVFile"),
      click: "downloadCSVFile",
      icon: "fas fa-download",
      requestProgress: true,
    });
    this.$emit("updateToolBar", buttons);
  }

  public mounted() {
    // activating tab
    this.$root.$emit("sidebar.layout.vue", "roPaymentReport");
    this.getRefundPreset();
    this.updateToolBar();
    this.$watch("methodtoCall", (newVal, oldVal) => {
      if (newVal) {
        this.callMethod(newVal);
      }
    });
    if (!this.flags.invalidUrl) {
      this.getUsers();
      this.getStatus();
      this.addWatchers();
      if (
        this.$route.query["selecteduser"] ||
        this.$route.query["paymentstatus"]
      ) {
        const keys = Object.keys(this.params);
        keys.forEach((key) => {
          if (this.$route.query[key]) {
            this.params[key] = this.$route.query[key];
          }
        });
      } else {
        this.params.selecteduser = "";
        this.params.paymentstatus = "";
      }
      this.setActions();
      this.getDefaultPaymentType();
      this.getPayments();
    }

    const roles = this.currentRoles;
    if (roles.indexOf(RoleType.AllowRefund) > -1) {
      this.isRefundAllowed = true;
    }
  }

  public setDateValues(dates: any) {
    if (dates.length > 1) {
      this.params.startDate = dates[0];
      this.params.endDate = dates[1];
    }
  }

  public addWatchers(): void {
    this.$watch("$route", (newVal, oldVal) => {
      this.params.startDate = newVal.query.startDate || this.presentDate();
      this.params.endDate = newVal.query.endDate || this.presentDate();
      this.params.selecteduser = newVal.query.selecteduser || "";
      this.params.paymentstatus = newVal.query.paymentstatus || "";
      this.getPayments();
    });
    this.$watch("showRefundPopup.model", (newVal, oldVal) => {
      if (!newVal) {
        return;
      }
      requestAnimationFrame(() => {
        this.$refs.refundAmount["focus"]();
      });
    });
  }
  public updatePaging(paging: any) {
    this.pagination = paging;
  }
  public updateFlag(flag, value): void {
    this.flags[flag] = value;
  }

  public async getRefundPreset(): Promise<void> {
    try {
      const refundPresets = await storeService.getRefundPresst(this.identifier);
      this.refundPreset = refundPresets;
    } finally {
    }
  }

  public getAccountNumber() {
    try {
      this.loading = true;

      this.hideAccountNumber = true;
      const account = this.refundPreset.filter(
        (item) => item.id == this.params.selectedAccountNumber
      );
      this.accountNumber = account[0].accountNumber;
    } finally {
      this.loading = false;
    }
  }

  public async getUsers(): Promise<void> {
    try {
      this.userLoading = true;
      const users = await userService.getStoreUsersListAsync();
      this.userList = users.results;
      this.userList.unshift({
        id: "",
        text: this.$t("repairOrderPaymentReport.selectAll"),
      });
    } finally {
      this.userLoading = false;
    }
  }
  public async getStatus(): Promise<void> {
    try {
      this.statusLoading = true;
      const response = await paymentReportService.getPaymentstatusList();
      this.statusList = response.results;
      this.statusList.unshift({
        id: "",
        text: this.$t("repairOrderPaymentReport.select"),
      });
    } finally {
      this.statusLoading = false;
    }
  }
  public searchPayments(): void {
    if (this.params.endDate < this.params.startDate) {
      this.showAlert(
        false,
        this.$t(
          "repairOrderPaymentReport.alertEndDateMustNotSmallerThanStartDate"
        )
      );
      return;
    }
    if (
      this.params.startDate > this.todayDate ||
      this.params.endDate > this.todayDate
    ) {
      this.showAlert(
        false,
        this.$t(
          "repairOrderPaymentReport.alertStartDateEndDateMustNotGreaterThanTodayDate"
        )
      );
      return;
    }
    const diff = Math.abs(
      new Date(this.params.endDate).getTime() -
      new Date(this.params.startDate).getTime()
    );

    const diffDays = Math.ceil(diff / (1000 * 3600 * 24));
    if (diffDays > 45) {
      this.showAlert(
        false,
        this.$t("repairOrderPaymentReport.alertSelectMaxDays")
      );
      return;
    }
    this.isSearchLoading = true;
    const keys = Object.keys(this.params);

    let url = Utils.API_BASE_URL + `/paymentreports?`;

    keys.forEach((key) => {
      if (this.params[key]) {
        url += `${key}=${this.params[key]}&`;
      }
    });
    const index = url.lastIndexOf("&");
    if (index >= 0) {
      url = url.substring(0, index);
    }
    this.getPayments();
  }

  public async getPayments(): Promise<void> {
    try {
      this.flags.loading = true;
      this.$emit("update:progress", this.flags.loading);
      const reports = await paymentReportService.getReport(
        this.params.startDate,
        this.params.endDate,
        this.params.selecteduser,
        this.params.paymentstatus,
        this.params.isLiveStatus
      );
      this.paymentReport = reports;
      if (!this.paymentReport.hasRefundAccess) {
        this.removeAction();
      }
      this.pagedPayment = this.paymentReport.payments;
      this.filterPagedPayment = this.paymentReport.payments;
      this.pagination.totalItems = this.pagedPayment.length;
      if (this.paymentReport.payments.length > 0) {
        this.paymentCsvFileReport = JSON.parse(
          JSON.stringify(this.paymentReport.payments)
        );
        this.paymentCsvFileReport = this.paymentCsvFileReport.map((item) => {
          if (item.customerName) {
            if (item.customerName.indexOf(",") !== -1) {
              item.customerName = `"${item.customerName}"`;
            }
          }
          if (item.advisorName) {
            if (item.advisorName.indexOf(",") !== -1) {
              item.advisorName = `"${item.advisorName}"`;
            }
          }
          if (item.roStatus === "CL") {
            item.roStatus = "Closed";
          }
          if (item.roStatus === "OP") {
            item.roStatus = "Open";
          }
          return item;
        });
        this.csvFileList = [];
        this.paymentCsvFileReport.forEach((item) => {
          this.csvFileModel = {};
          this.csvFileModel.status = item.roStatus;
          this.csvFileModel.repairOrderNumber = item.repairOrderNumber;
          this.csvFileModel.customerName = item.customerName;
          this.csvFileModel.advisorName = item.advisorName;
          this.csvFileModel.date = item.date;
          this.csvFileModel.roStaus = item.status;
          this.csvFileModel.approvalNumber = "";
          this.csvFileModel.cardLastFour = "";
          this.csvFileModel.acceptorIdLastFour = "";
          this.csvFileModel.paymentMethod = item.paymentMethod;
          this.csvFileModel.paymentType = "";
          this.csvFileModel.cardLogo = "";
          this.csvFileModel.amount = item.amount;
          this.csvFileList.push(this.csvFileModel);
          item.paymentResponses.forEach((element) => {
            this.csvFileModel = {};
            this.csvFileModel.status = item.status;
            this.csvFileModel.repairOrderNumber = item.repairOrderNumber;
            this.csvFileModel.customerName = item.customerName;
            this.csvFileModel.advisorName = item.advisorName;
            this.csvFileModel.date = element.date;
            this.csvFileModel.roStaus = element.status;
            this.csvFileModel.approvalNumber = element.approvalNumber;
            this.csvFileModel.cardLastFour = element.cardLastFour;
            this.csvFileModel.acceptorIdLastFour = element.acceptorIdLastFour;
            this.csvFileModel.paymentMethod = element.paymentMethod;
            this.csvFileModel.paymentType = element.paymentType;
            this.csvFileModel.cardLogo = element.cardLogo;
            this.csvFileModel.amount = element.approvedAmount;
            this.csvFileList.push(this.csvFileModel);
          });
          this.csvFileModel = {};
          this.csvFileList.push(this.csvFileModel);
        });
      } else {
        this.csvFileList = [];
        this.paymentCsvFileReport = [];
      }
    } finally {
      this.flags.loading = false;
      this.isSearchLoading = false;
      this.$emit("update:progress", this.flags.loading);
    }
  }
  public getPaymentResponse(
    payment: PaymentDetailViewModel
  ): PaymentDetailResponseViewModel[] {
    this.pagedPaymentResponse = payment.paymentResponses;
    const result = this.pagedPaymentResponse.map((item) => {
      (item.transactionHeaderId = payment.transactionHeaderId),
        (item.laneId = payment.laneId),
        (item.storeId = payment.storeId),
        (item.roNumber = payment.repairOrderNumber);
      return item;
    });

    return result;
  }
  public updateUser(val): void {
    this.params.selecteduser = val;
  }
  public showRefund(payment: PaymentDetailViewModel): void {
    this.paymentToRefund = payment;
    this.refund.transactionAmount = "";
    this.showRefundPopup.model = true;
    this.getAccountNumber();
  }

  public confirmRefund(): void {
    if (Number(this.refund.transactionAmount) <= 0) {
      this.showAlert(false, "Amount can not be 0");
      return;
    }

    if (!this.params.selectedAccountNumber) {
      this.showAlert(false, "Please Select Preset Refund Account.");
      return;
    }

    if (this.refund.transactionAmount > this.paymentToRefund.approvedAmount) {
      this.showAlert(
        false,
        "Refund Amount Can not be greater than Paid Amount, Or please Refresh if you have already processed refund"
      );
      return;
    }

    var accountDetails = this.refundPreset.filter(
      (x) => x.id == this.params.selectedAccountNumber
    )[0];
    if (
      accountDetails != null &&
      accountDetails != undefined &&
      !accountDetails.isDmsPostAllowed
    ) {
      this.showAlert(
        false,
        "As per selected configuration debit and credit Account/Control details are same , So Transaction is not allowed."
      );
      return;
    }

    this.confirmRefundDialog.model = true;
  }

  public async processRefund(): Promise<void> {
    try {
      this.showRefundPopup.action.disable = true;
      this.confirmRefundDialog.action.disable = true;
      if (this.isRefundAllowed) {
        const refund = await paymentReportService.processRefund(this);
        this.showRefundPopup.model = false;
        this.showAlert(true, refund.statusMessage);
        this.refundPreset = [];
        this.accountNumber = "";
        this.params.selectedAccountNumber = "";
        this.getRefundPreset();
        this.getAccountNumber();
        this.getPayments();
      } else {
        this.showAlert(
          false,
          "You are not allowed refund, Please contact Admin"
        );
      }
    } catch (e) {
      console.log(e);
    } finally {
      this.showRefundPopup.action.disable = false;
      this.confirmRefundDialog.action.disable = false;
      this.showRefundPopup.model = false;
      this.confirmRefundDialog.model = false;
    }
  }

  public removeAction(): void {
    const action = this.headers.find((m) => m.text === "Action");
    if (action) {
      const index = this.headers.indexOf(action);
      if (index >= 0) {
        this.headers.splice(index, 1);
      }
      this.actions.length = 0;
    }
  }

  public searchPayment(): void {
    this.filterPagedPayment = [];
    this.pagedPayment.forEach((payment, index) => {
      const paymentResponses = payment.paymentResponses.filter((res) => {
        if (
          (res.approvalNumber &&
            res.approvalNumber.toString().indexOf(this.search) !== -1) ||
          (res.cardLastFour &&
            res.cardLastFour.toString().indexOf(this.search) !== -1) ||
          (res.acceptorIdLastFour &&
            res.acceptorIdLastFour.toString().indexOf(this.search) !== -1) ||
          (!isNaN(res.approvedAmount) &&
            res.approvedAmount.toFixed(2).toString().indexOf(this.search) !==
            -1)
        ) {
          return true;
        }
      });
      if (paymentResponses.length === 0) {
        if (
          (payment.repairOrderNumber &&
            payment.repairOrderNumber.toString().indexOf(this.search) !== -1) ||
          (payment.customerName &&
            payment.customerName.toString().toLowerCase().includes(this.search.toLowerCase())) ||
          (payment.advisorName &&
            payment.advisorName.toString().toLowerCase().includes(this.search.toLowerCase())) ||
          (payment.status &&
            payment.status.toString().indexOf(this.search) !== -1) ||
          (!isNaN(payment.amount) &&
            payment.amount.toFixed(2).toString().indexOf(this.search) !== -1)
        ) {
          const res = JSON.parse(JSON.stringify(payment));
          this.filterPagedPayment.push(res);
        }
      } else {
        const res = JSON.parse(JSON.stringify(payment));
        this.filterPagedPayment.push(res);
        this.filterPagedPayment[
          this.filterPagedPayment.length - 1
        ].paymentResponses = paymentResponses;
      }
    });
  }

  public downloadCSVFile() {
    downloadCsv(
      this.csvFileList,
      this.columns1,
      "partSales_payment_report.csv"
    );
  }

  public async getDefaultPaymentType(): Promise<void> {
    try {
      const result = await repairOrderService.getDefaultPaymentProvider();
      this.paymentProvider = result.paymentProvider;
    } finally {
      // finally block
    }
  }

  public async downloadReceipt(request): Promise<void> {
    try {
      this.isReceiptDownloading = true;
      const response = await paymentReportService.downloadReceipt(
        request.transactionHeaderId,
        request.transactionId,
        request.paymentType
      );

      if (response?.fileDownloadName) {
        this.isReceiptDownloading = false;
        window.open(response.fileDownloadName, '_blank');
      } else {
        this.showNotification(NotificationType.Warning, "Receipt is not available for this transaction.");
      }
    } finally {
      this.isReceiptDownloading = false;
    }
  }

  public showRetryDmsPost(payment: PaymentDetailViewModel): void {
    this.retryDmsTxId = payment.transactionHeaderId;
    this.retryDmsPaymentDetailId = payment.id;
    this.retryDmsPostStoreId = payment.storeId;
    this.retryDmsRoNumber = payment.repairOrderNumber;
    this.glRetryDialogPopup.model = true;
  }

  public async retryGlPost() {
    try {
      this.glRetryDialogPopup.loading = true;
      // var adhocRes = await adhocPaymentService.retryAdHocGlPostRequest(
      //   this.receiptNumber
      // );

      var res = await paymentService.retryPaymentGlPost(
        "ro",
        this.retryDmsTxId,
        this.retryDmsPaymentDetailId,
        this.retryDmsRoNumber
      );

      if (res.isSuccess) {
        this.showAlert(true, "Gl Data Posted Successfully");
        window.location.reload();
      } else {
        this.showAlert(false, "Failed to post Gl data");
      }
    } finally {
      this.retryDmsTxId = "";
      this.retryDmsPaymentDetailId = "";
      this.retryDmsRoNumber = "";
      this.glRetryDialogPopup.model = false;
      this.glRetryDialogPopup.loading = false;
    }
  }

  public clearDates() {
      this.params.startDate = this.presentDate();
      this.params.endDate = this.presentDate();
      this.calendarKey++;
  }

  public toTitleCase(value: string): string {
  if (!value) return '';

  return value
    .toLowerCase()
    .split(' ')
    .map(word =>
      word.replace(/[a-z]/, char => char.toUpperCase())
    )
    .join(' ');
}

get formattedPayments() {
  return this.filterPagedPayment.map(item => ({
    ...item,
    customerName: this.toTitleCase(item.customerName),
    advisorName: this.toTitleCase(item.advisorName),
  }));
}
}
export default PaymentReportPage;
